import React from "react";
import { Route } from "react-router-dom";
import { URL } from "../url";
import SignInScene from "../../01_Login/login";
import DevScreen from "screen/100_Dev/dev";
// import DevScreen from "screen/100_Dev/dev";

export const routePublict = () => {
  // -------------------------- STATE --------------------------

  // -------------------------- FUNCTION --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------

  return (
    <>
      <Route exact path={URL.home} element={<SignInScene />} />
      {/* <Route path={URL.dev} element={<DevScreen />} /> */}
    </>
  );
};
